module.exports = __webpack_public_path__ + "img/03.70c32d70.jpg";